var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMetricsHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#8ADCBD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17.5,
    width: 7,
    height: 12,
    rx: 2,
    fill: "#FCFCFC"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3.5,
    width: 26,
    height: 8,
    rx: 2,
    transform: "rotate(90 29 3.5)",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8.5,
    width: 21,
    height: 7,
    rx: 2,
    transform: "rotate(90 19 8.5)",
    fill: "#FCFCFC"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#3CC491"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMetricsHovered);
export default __webpack_public_path__ + "static/media/menu-metrics-hovered.6a5ac200067e2b783335066971a6da83.svg";
export { ForwardRef as ReactComponent };